// jshint strict:false, undef:false, unused:false

/*/
	Browser Support
	Stephen Ginn at Crema Design Studio
	Last Updated on 2019-07-26
/*/

// @codekit-prepend '@cremadesign/cremastrap/plugins/modernizr/3.6.0.js';
// @codekit-prepend "@cremadesign/cremastrap/plugins/crema/js/compat.js";
// @codekit-prepend "@cremadesign/cremastrap/plugins/crema/js/tls-support.js";
